const SERVER_URL = (
  process.env.REACT_APP_SERVER_URL ||
  "https://rosemountstaffserver.onrender.com"
).replace(/\/$/, "");

export const getBankOfEnglandRate = async ({ date, includeHistory = false } = {}) => {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (includeHistory) params.set("includeHistory", "true");
  const query = params.toString();
  const response = await fetch(
    `${SERVER_URL}/api/bank-of-england-rate${query ? `?${query}` : ""}`,
  );
  if (!response.ok) {
    throw new Error(`Bank Rate request failed with status ${response.status}.`);
  }
  return response.json();
};
